window.addEventListener('alpine:init', () => {
  var { removeSectionWrapper, getDefaultAlpineMorphLifecycleHooks } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function productRecommendations(data = {}) {
    return {
      ...data,

      isLoadingProductRecommendations: false,

      onIntersect() {
        this.isLoadingProductRecommendations = true;

        var url = new URL(`${location.origin}${window.global.routes.product_recommendations_url}`);

        url.searchParams.set('product_id', this.productId);
        url.searchParams.set('section_id', this.sectionId);
        url.searchParams.set('intent', this.intent);
        url.searchParams.set('limit', this.limit || 8);

        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingProductRecommendations = false;
          });
      }
    };
  };

  Alpine.data('productRecommendations', productRecommendations);
});
